export default __webpack_public_path__ + "static/media/13.d4cb2756.jpg";